/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Swiper from '@components/Swiper';
import ProductCardContainer from '@results/HOCs/ProductCardContainer';
import { getProductCardProps } from '@results/HOCs/ProductCardContainer/ProductCardContainer';
import SwimlaneCardContainer from '@results/HOCs/SwimlaneCardContainer';
import { SWIMLANES } from '@shopDetails/constants';
import { Title, ProductCard } from './components';
import message from './message';

function PreferredDishesSwimlane({
  intl: { formatMessage },
  title,
  swimlaneId,
  products,
  onBeforeProductConfig,
  shopUrl,
  swimlaneShown,
  swimlaneSwiped,
  position,
}) {
  const mainTitle = useMemo(
    () => title || formatMessage(message.preferred_dishes_title),
    [formatMessage, title],
  );

  const swipeId = useMemo(() => swimlaneId || 'preferred-dishes-section-id', [
    swimlaneId,
  ]);

  useEffect(() => {
    swimlaneShown(products, SWIMLANES.PREFERRED_DISHES, position);
  }, [position]);

  const handleOnScrollFinish = currentIndex => {
    swimlaneSwiped({
      title: SWIMLANES.PREFERRED_DISHES,
      type: 'product',
      screenType: 'shop_details',
      position: currentIndex,
      products,
    });
  };

  return (
    <>
      <Title>{mainTitle}</Title>
      <Swiper id={swipeId} onScrollFinish={handleOnScrollFinish}>
        {products.map((product, index) => (
          <ProductCardContainer
            key={product.id}
            onBeforeProductConfig={onBeforeProductConfig}
            shopUrl={shopUrl}
            {...getProductCardProps(product)}
          >
            {onProductClick => (
              <SwimlaneCardContainer
                item={product}
                onClick={onProductClick}
                positionItem={index}
                swimlane={{ code: SWIMLANES.PREFERRED_DISHES }}
                swimlanePosition={position}
              >
                {onClick => (
                  <ProductCard
                    product={product}
                    onClick={onClick}
                    menuSection={`widget_${SWIMLANES.PREFERRED_DISHES}`}
                  />
                )}
              </SwimlaneCardContainer>
            )}
          </ProductCardContainer>
        ))}
      </Swiper>
    </>
  );
}

PreferredDishesSwimlane.propTypes = {
  intl: intlShape.isRequired,
  image: PropTypes.string,
  title: PropTypes.string,
  swimlaneId: PropTypes.string,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  onBeforeProductConfig: PropTypes.func.isRequired,
  shopUrl: PropTypes.string.isRequired,
  swimlaneShown: PropTypes.func.isRequired,
  swimlaneSwiped: PropTypes.func.isRequired,
  position: PropTypes.number.isRequired,
};

export default injectIntl(PreferredDishesSwimlane);
